import React from "react";
import PlaybookIcon from "@material-ui/icons/AssignmentTurnedIn";
import HelpIcon from "@material-ui/icons/Help";
import {
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@material-ui/core";
import ToolbarCheckbox from "common_components/toolbar/checkbox";
import {IssueOverrideTag} from "common/types/issue_override_tag";
import {MaybeLoading} from "common/types/util";

interface PlaybooksToolbarProps {
  showArchivedIssuesets: boolean;
  showArchivedIssues: boolean;
  showHiddenIssues: boolean;
  selectedIssueOverrideTag: string;
  issueOverrideTags: MaybeLoading<IssueOverrideTag[]>;
  canViewIssueTags: boolean;
  onOverrideTagChange: (event: React.ChangeEvent<{value: string}>) => void;
  onToggleArchivedIssuesets: () => void;
  onToggleArchivedIssues: () => void;
  onToggleHiddenIssues: () => void;
  isAdmin: boolean;
  tabValue: number;
}

const PlaybooksToolbar: React.FC<PlaybooksToolbarProps> = ({
  showArchivedIssuesets,
  showArchivedIssues,
  showHiddenIssues,
  selectedIssueOverrideTag,
  issueOverrideTags,
  canViewIssueTags,
  onOverrideTagChange,
  onToggleArchivedIssuesets,
  onToggleArchivedIssues,
  onToggleHiddenIssues,
  isAdmin,
  tabValue,
}) => {
  const renderOverrideTagSelector = () => {
    if (!canViewIssueTags || tabValue === 1) {
      return null;
    }

    const tags = Array.isArray(issueOverrideTags) ? issueOverrideTags : [];

    return (
      <div style={{display: "flex", alignItems: "center"}}>
        <FormControl
          variant="outlined"
          size="small"
          style={{
            minWidth: 200,
            marginRight: 8,
          }}
        >
          <InputLabel>Override Tag</InputLabel>
          <Select
            value={selectedIssueOverrideTag || ""}
            onChange={onOverrideTagChange}
            label="Override Tag"
            disabled={!tags.length}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {tags.map(tag => (
              <MenuItem key={tag.id} value={tag.id}>
                {tag.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {!tags.length && (
          <Tooltip title="Create new tags on the projects settings page">
            <HelpIcon style={{color: "#666", fontSize: 30}} />
          </Tooltip>
        )}
      </div>
    );
  };

  const renderCheckboxes = () => {
    const checkboxesDataArray = [
      {
        name: "showArchivedIssuesets",
        label: "Show Archived Issuesets",
        checked: showArchivedIssuesets,
        handler: onToggleArchivedIssuesets,
      },
      {
        name: "showArchivedIssues",
        label: "Show Archived Issues",
        checked: showArchivedIssues,
        handler: onToggleArchivedIssues,
      },
      {
        name: "showHiddenIssues",
        label: "Show Hidden Issues",
        checked: showHiddenIssues,
        handler: onToggleHiddenIssues,
      },
    ];

    return checkboxesDataArray.map(item => (
      <ToolbarCheckbox
        key={item.name}
        checked={item.checked}
        label={item.label}
        onCheck={item.handler}
      />
    ));
  };

  return (
    <div
      className="app-toolbar"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div style={{display: "flex", alignItems: "center"}}>
        <PlaybookIcon style={{marginRight: 8, color: "#1f88e5"}} />
        <Typography
          style={{marginRight: 18, fontSize: "1.25rem", fontWeight: 500}}
          color="textSecondary"
          variant="h1"
        >
          Playbooks
        </Typography>
        {isAdmin && renderCheckboxes()}
      </div>
      {renderOverrideTagSelector()}
    </div>
  );
};

export default PlaybooksToolbar;
